import { useMediaQuery } from '@mui/material';
import { Navigate } from 'react-router-dom';

const DeviceIsMobile = ({ to = 'announcement' }) => {
  const deviceIsMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  return deviceIsMobile ? <Navigate to={'/home/'+to} /> : <Navigate to={to} />;
};

export default DeviceIsMobile;
